import Header from '../../components/Header';

const PluginPromptGnb = () => {
  const menus = ['Agent', 'Template'];

  return <Header title="Works AI Makers" menus={menus} />;
};

export default PluginPromptGnb;
